import axios from "./config";
import { getHeader, getUserInfo } from "../utility/index";


const getEmployeeList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/visit-activity-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const visitReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/customer/${user_info.emp_id}/visit-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};


const visitSummryReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/visit-summary-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const shopLicenseReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/shop-license-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const KAKRReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/KA-KR-price-survey-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const KAKRStockReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/KA-KR-stock-check-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};



const getAllCustomerList = async (): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.get<any>(
    `/reports/${user_info.emp_id}/all-customers`,
    {
      headers: getHeader(),
    }
  );
  return response.data;
};
const b2bReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/b2b/${user_info.emp_id}/orders-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const b2bFeedbackReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/b2b/${user_info.emp_id}/order-feedback-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const SFAFeedbackCustomerReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/sfa-customer-feedback-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const syncB2BOrderOnSAP = async (orderId: string | number): Promise<any> => {
  const user_info = getUserInfo();
  const response = await axios.post<any>(
    `/b2b/${orderId}/sync-on-sap`,
    {},
    {
      headers: getHeader(),
    }
  );
  return response.data;
};

const videoviewReportList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/training-video-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const getHorecaCollectionReport = async (params: any, data: any): Promise<any> => {
    const user_info = getUserInfo();
  
    const response = await axios.post<any>(
      `/reports/${user_info.emp_id}/horeca-collection-report`,
      data,
      {
        headers: getHeader(),
        params: params,
      }
    );
    return response.data;
  };
  const getHorecaStockReport = async (params: any, data: any): Promise<any> => {
    const user_info = getUserInfo();
  
    const response = await axios.post<any>(
      `/reports/${user_info.emp_id}/horeca-stock-health-report`,
      data,
      {
        headers: getHeader(),
        params: params,
      }
    );
    return response.data;
  };
 
  const getQuaterlyConfirmationReport = async (params: any, data: any): Promise<any> => {
    const user_info = getUserInfo();
  
    const response = await axios.post<any>(
      `/reports/${user_info.emp_id}/horeca-balance-confirmation-report`,
      data,
      {
        headers: getHeader(),
        params: params,
      }
    );
    return response.data;
  };
  const getCustomerVisitsReport = async (params: any, data: any): Promise<any> => {
    const user_info = getUserInfo();
  
    const response = await axios.post<any>(
      `/reports/${user_info.emp_id}/customer-visits-report`,
      data,
      {
        headers: getHeader(),
        params: params,
      }
    );
    return response.data;
  };
export {
  visitReportList,
  visitSummryReportList,
  getAllCustomerList,
  KAKRReportList,
  KAKRStockReportList,
  b2bReportList,
  syncB2BOrderOnSAP,
  b2bFeedbackReportList,
  SFAFeedbackCustomerReportList,
  shopLicenseReportList,
  videoviewReportList,
  getHorecaCollectionReport,
  getHorecaStockReport,
  getQuaterlyConfirmationReport,
  getCustomerVisitsReport
};
export default getEmployeeList;
